/**
 * Desktop navigatie (≥992px): menu opent alleen met klik (sidebar), nooit met hover.
 */
(function () {
  'use strict';

  var MQ_DESKTOP = '(min-width: 992px)';
  var mqDesktop = window.matchMedia(MQ_DESKTOP);
  var bound = false;
  var active = false;

  function menuBar() {
    return document.querySelector('.header .menu_bar');
  }

  function menuRoot() {
    var bar = menuBar();
    return bar ? bar.querySelector('.menu') : null;
  }

  function isClickMode() {
    if (!menuRoot()) return false;
    return mqDesktop.matches;
  }

  function captureNavHrefs() {
    var root = menuRoot();
    if (!root) return;

    root.querySelectorAll('li').forEach(function (li) {
      if (!li.querySelector(':scope > ul')) return;
      var a = li.querySelector(':scope > a');
      if (!a) return;

      var href = (a.getAttribute('href') || '').trim();
      if (href && href !== '#' && href.indexOf('javascript') !== 0) {
        a.dataset.ufNavHref = href;
      }
    });
  }

  function restoreNavHrefs() {
    var root = menuRoot();
    if (!root) return;

    root.querySelectorAll('li').forEach(function (li) {
      if (!li.querySelector(':scope > ul')) return;
      var a = li.querySelector(':scope > a');
      if (!a || !a.dataset.ufNavHref) return;
      a.setAttribute('href', a.dataset.ufNavHref);
    });
  }

  function setMode(on) {
    document.documentElement.classList.toggle('uf-nav-click-mode', on);
  }

  function closeAllSlides() {
    var root = menuRoot();
    if (!root) return;
    root.querySelectorAll('.slide').forEach(function (li) {
      li.classList.remove('slide');
      syncAria(li);
    });
  }

  function syncAria(li) {
    var a = li.querySelector(':scope > a');
    if (!a) return;
    var open = li.classList.contains('slide');
    a.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function dropdownLiFromTarget(target) {
    var root = menuRoot();
    if (!root || !target || !root.contains(target)) return null;
    var a = target.closest('a');
    if (!a) return null;
    var li = a.parentElement;
    if (!li || li.tagName !== 'LI' || li.querySelector(':scope > a') !== a) return null;
    if (!li.querySelector(':scope > ul')) return null;
    return li;
  }

  function isTopLevel(li) {
    var ul = li && li.parentElement;
    return !!(ul && ul.matches('.menu > ul'));
  }

  function getDropdownHref(li) {
    var a = li && li.querySelector(':scope > a');
    if (!a) return '';
    var href = (a.dataset.ufNavHref || a.getAttribute('href') || '').trim();
    if (!href || href === '#' || href.indexOf('javascript') === 0) return '';
    return href;
  }

  function navigateDropdown(li) {
    var href = getDropdownHref(li);
    if (!href) return false;
    window.location.assign(href);
    return true;
  }

  function openTopLevel(li) {
    var wasOpen = li.classList.contains('slide');
    menuRoot().querySelectorAll(':scope > ul > li.slide').forEach(function (item) {
      item.classList.remove('slide');
      syncAria(item);
    });
    if (!wasOpen) {
      li.classList.add('slide');
    }
    syncAria(li);
    syncPvcDropdownPosition(li);
  }

  function toggleNested(li) {
    var wasOpen = li.classList.contains('slide');
    var parent = li.parentElement;
    if (parent) {
      parent.querySelectorAll(':scope > li.slide').forEach(function (item) {
        if (item !== li) {
          item.classList.remove('slide');
          syncAria(item);
        }
      });
    }
    li.classList.toggle('slide', !wasOpen);
    syncAria(li);
    syncPvcDropdownPosition(li);
  }

  function syncPvcDropdownPosition(li) {
    if (!li || !li.classList.contains('slide')) return;
    if (typeof window.ufUpdatePvcDropdownTop !== 'function') return;
    window.requestAnimationFrame(function () {
      window.ufUpdatePvcDropdownTop();
    });
  }

  function onTriggerClick(e) {
    if (!isClickMode()) return;
    var li = dropdownLiFromTarget(e.target);
    if (!li) return;

    /* Tweede klik terwijl open → door naar collectie/pagina */
    if (li.classList.contains('slide') && getDropdownHref(li)) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    if (isTopLevel(li)) {
      openTopLevel(li);
    } else {
      toggleNested(li);
    }
  }

  function onTriggerKeydown(e) {
    if (!isClickMode()) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var li = dropdownLiFromTarget(e.target);
    if (!li) return;

    if (li.classList.contains('slide') && navigateDropdown(li)) {
      e.preventDefault();
      return;
    }

    e.preventDefault();
    if (isTopLevel(li)) {
      openTopLevel(li);
    } else {
      toggleNested(li);
    }
  }

  function onBarFocusOut(e) {
    if (!isClickMode()) return;
    var bar = menuBar();
    if (!bar || !bar.contains(e.target)) return;
    var next = e.relatedTarget;
    if (next && bar.contains(next)) return;
    closeAllSlides();
  }

  function onDocumentPointerDown(e) {
    if (!isClickMode()) return;
    var bar = menuBar();
    if (!bar || bar.contains(e.target)) return;
    closeAllSlides();
  }

  function disableLegacyHover() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    $('.menu-dropdown-icon').off('mouseenter mouseleave');
    $(document).off('mouseenter', '.menu-dropdown-icon');
    $(document).off('mouseleave', '.menu-dropdown-icon');
  }

  function disableLegacyTabletNav() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    $('.menu-dropdown-icon').off('click touchstart');
    restoreNavHrefs();
  }

  function stripHoverSlides() {
    if (!isClickMode()) return;
    var root = menuRoot();
    if (!root) return;
    root.querySelectorAll('li.slide').forEach(function (li) {
      li.classList.remove('slide');
      syncAria(li);
    });
  }

  function onMenuMouseOver(e) {
    if (!isClickMode()) return;
    var bar = menuBar();
    if (!bar || !e.target || !bar.contains(e.target)) return;
    window.setTimeout(stripHoverSlides, 0);
  }

  function primeTriggers() {
    captureNavHrefs();
    restoreNavHrefs();

    var root = menuRoot();
    if (!root) return;
    root.querySelectorAll('.menu > ul > li').forEach(function (li) {
      if (!li.querySelector(':scope > ul')) return;
      var a = li.querySelector(':scope > a');
      if (!a) return;
      a.setAttribute('aria-expanded', li.classList.contains('slide') ? 'true' : 'false');
      if (isClickMode() && !getDropdownHref(li)) {
        a.setAttribute('role', 'button');
      } else {
        a.removeAttribute('role');
      }
    });
  }

  function bind() {
    if (bound) return;
    var bar = menuBar();
    if (!bar) return;
    bound = true;
    bar.addEventListener('click', onTriggerClick, true);
    bar.addEventListener('keydown', onTriggerKeydown, true);
    bar.addEventListener('focusout', onBarFocusOut);
    document.addEventListener('pointerdown', onDocumentPointerDown, true);
  }

  function unbind() {
    if (!bound) return;
    var bar = menuBar();
    if (bar) {
      bar.removeEventListener('click', onTriggerClick, true);
      bar.removeEventListener('keydown', onTriggerKeydown, true);
      bar.removeEventListener('focusout', onBarFocusOut);
    }
    document.removeEventListener('pointerdown', onDocumentPointerDown, true);
    bound = false;
  }

  function apply() {
    var on = isClickMode();
    if (on === active) {
      if (on) {
        disableLegacyHover();
        disableLegacyTabletNav();
        primeTriggers();
        stripHoverSlides();
      }
      return;
    }
    active = on;
    setMode(on);
    if (on) {
      disableLegacyHover();
      disableLegacyTabletNav();
      bind();
      primeTriggers();
      stripHoverSlides();
    } else {
      unbind();
      closeAllSlides();
      setMode(false);
    }
  }

  function init() {
    captureNavHrefs();
    apply();
    document.addEventListener('mouseover', onMenuMouseOver, true);

    if (typeof mqDesktop.addEventListener === 'function') {
      mqDesktop.addEventListener('change', apply);
    } else if (typeof mqDesktop.addListener === 'function') {
      mqDesktop.addListener(apply);
    }
    window.addEventListener('resize', apply, { passive: true });

    document.addEventListener('uf-nav-dyn-ready', function () {
      if (isClickMode()) {
        disableLegacyHover();
        stripHoverSlides();
      }
      primeTriggers();
      if (isClickMode() && typeof window.ufUpdatePvcDropdownTop === 'function') {
        window.ufUpdatePvcDropdownTop();
      }
    });

    /* timber.js kan hrefs op tablet wissen — opnieuw herstellen na load */
    window.addEventListener('load', function () {
      window.setTimeout(function () {
        if (isClickMode()) {
          disableLegacyHover();
          disableLegacyTabletNav();
          stripHoverSlides();
          primeTriggers();
        }
      }, 0);
    });
  }

  /* Vóór timber.js: hrefs bewaren zodat tweede klik naar collectie kan */
  document.addEventListener('DOMContentLoaded', captureNavHrefs, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
